/**
 * PushNotificationButton.jsx
 *
 * Botón en el sidebar que permite al usuario activar/desactivar
 * las notificaciones push web via OneSignal.
 */
import React, { useEffect, useState } from 'react';

const PushNotificationButton = () => {
  const [supported, setSupported] = useState(false);
  const [permission, setPermission] = useState('default'); // 'default' | 'granted' | 'denied'
  const [loading, setLoading] = useState(false);

  // Detectar si Notification API está disponible
  useEffect(() => {
    const ok = 'Notification' in window;
    setSupported(ok);
    if (ok) setPermission(Notification.permission);
  }, []);

  // No renderizar si no hay soporte o ya fue denegado definitivamente
  if (!supported || permission === 'denied') return null;

  const handleClick = async () => {
    setLoading(true);
    try {
      const OneSignal = window.OneSignal;
      if (!OneSignal) {
        console.warn('[push] OneSignal aún no cargado');
        return;
      }
      if (permission === 'granted') {
        await OneSignal.User.PushSubscription.optOut();
        setPermission('default');
      } else {
        await OneSignal.Notifications.requestPermission();
        setPermission(Notification.permission);
      }
    } catch (e) {
      console.warn('[push] error al solicitar permiso:', e);
    } finally {
      setLoading(false);
    }
  };

  const isActive = permission === 'granted';

  return (
    <button
      className="sb-push-btn"
      onClick={handleClick}
      disabled={loading}
      title={isActive ? 'Desactivar notificaciones push' : 'Activar notificaciones push'}
      style={{
        background: 'none',
        border: 'none',
        cursor: loading ? 'wait' : 'pointer',
        padding: '6px',
        borderRadius: '6px',
        color: isActive ? '#10b981' : 'var(--sb-text-muted, #9ca3af)',
        fontSize: '18px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'color 0.2s',
      }}
    >
      <i className={`bi bi-bell${isActive ? '-fill' : ''}`} />
    </button>
  );
};

export default PushNotificationButton;
